

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AppLayout from "./components/layout/AppLayout";
import DeliveryDashboard from "./pages/dashBoard/DeliveryDashboard";
import DeliveryBoyProfile from "./pages/Profile/DeliveryProfile";
import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/signUp";
import Forget from "./pages/ForgetPassword/Forget";
import DeliveryHistory from "./pages/history/DeliveryHistory";
import MyEarnings from "./pages/MyEarning/MyEarnings";
import Support from "./pages/Support/Support";
import Payment from "./pages/Payment/Payment";
import DeliveryTermsConditions from "./pages/Terms/DeliveryTermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        {/* Toast Container for notifications */}
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          limit={3}
        />

        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot" element={<Forget />} />

          {/* Protected routes with AppLayout */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <DeliveryDashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <DeliveryBoyProfile />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <DeliveryHistory />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/earnings"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <MyEarnings />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Support />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Payment />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/terms-and-conditions"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <DeliveryTermsConditions />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <PrivacyPolicy />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;

